export default ($) => {

  $(() => {
    const $window = $(window)


    /**
     * テキストアニメーションのターゲット要素
     * @type {Array}
     */
    const textAnimationTargets = document.querySelectorAll('.js-textAnimation')

    for (let i = 0; i < textAnimationTargets.length; i++) {
      const textAnimationText = textAnimationTargets[i].textContent
  
      textAnimationTargets[i].innerHTML = '';
  
      textAnimationText.split('').forEach(char => {
        if (char !== ' ') {
          textAnimationTargets[i].innerHTML += '<span>' + char + '</span>'
        } else {
          textAnimationTargets[i].innerHTML += char
        }
      });
    }

    /**
     * アニメーションのターゲット各要素のjQueryオブジェクトを配列で格納
     * @type {Array}
     */
    var $animationTargets = [];
    $(".js-animation").each(function() {
      $animationTargets.push($(this));
    });

    if($animationTargets.length) {
      $window.on("load scroll", function() {
        updateAnimation();
      });
    }

    /**
     * アニメーションの状態を更新する
     */
    function updateAnimation() {
      /**
       * 画面の縦スクロール位置
       * @type {Number}
       */
      var windowScrollTop = $window.scrollTop();
      /**
       * 画面の高さ
       * @type {Number}
       */
      var windowHeight = $window.height();
      var applyPosition = $window.width() > 768 ? 4 / 5 : 1;
      for(var i = 0; i < $animationTargets.length; i++) {
        if((windowScrollTop + windowHeight * applyPosition) > $animationTargets[i].offset().top) {
          $animationTargets[i].addClass("is-animated");
        }
      }
    }

    /**
     * スムーススクロール実装
     */
    $('a[href*="#"].js-scroll, area[href*="#"].js-scroll, .article__body a[href*="#"]').on('click', function (e) {
      e.preventDefault();
      window.smoothScroll($(this).prop('href'))
    })

    /**
     * ハッシュリンクの位置を調整
     */
    const hashPosFix = () => {
      if (location.hash) {
        window.smoothScroll(location.href, false, 0)
      }
    }
    hashPosFix()
    $window.on('hashchange', () => {
      hashPosFix()
    })
    



    if ($('.topLink').length) {
      const $topLink = $('.topLink')
      let topLinkTimer = setTimeout(() => {
        clearTimeout(topLinkTimer)
        $topLink.addClass('is-hide')
      }, 4000);
      $topLink.on('click', () => {
        if ($window.width() <= 768 && $topLink.hasClass('is-hide')) {
          $topLink.removeClass('is-hide')
          let topLinkTimer = setTimeout(() => {
            clearTimeout(topLinkTimer)
            $topLink.addClass('is-hide')
          }, 4000);
          return false;
        }
      })
    }

  })

}